import { useTranslation } from 'react-i18next';
import type { MoleculeFacts } from '@peruselab/api-client/molecules';
import { Icon } from '../../../components/Icon';

/**
 * #1079 / ADR 0020 D9: a structure the check holds back (Na⁻, C²⁻, Na–O drawn bonded) is most
 * likely a slip, so PeruseLab doesn't look it up in PubChem. The Monograph says so where it would
 * otherwise say "no published information" or "unavailable" -- both of which read as if PubChem had
 * been asked. #1106: what the check found is the Structure check line's to say; this points at it.
 */
export function UnusualChargeNote({ facts }: { readonly facts: MoleculeFacts | null }) {
  const { t } = useTranslation();
  // A server from before #1101 sends no `heldBack`: then the note is left out, not the page.
  const heldBack = facts?.status === 'implausible' ? (facts.heldBack ?? []) : [];
  if (heldBack.length === 0) return null;
  return (
    <p className="molecule-factsheet-gap" role="note" data-testid="unusual-charge-note">
      <Icon name="info" size="1rem" />
      <span>{t('moleculePage.unusualCharge.note')}</span>
    </p>
  );
}
